<div class="text-wrapper" *ngIf="parsedTextTemplate$ | async">
  <div class="c-card__property">
    <ax-value-view
      class="rich-text"
      type="RICH_TEXT"
      [value]="parsedTextTemplate$ | async"
    ></ax-value-view>
  </div>
</div>
